'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var AnimalTypeService = function () {
  function AnimalTypeService($http) {
    'ngInject';

    _classCallCheck(this, AnimalTypeService);

    this.$http = $http;
  }

  _createClass(AnimalTypeService, [{
    key: 'getAnimalTypes',
    value: function getAnimalTypes() {
      return this.$http.get('/api/animal_type');
    }
  }, {
    key: 'minimumAnimalWeight',
    value: function minimumAnimalWeight(animalType) {
      if (!animalType) {
        return 0.0;
      }

      switch (animalType) {
        case 'Horse':
          return 100.0;
        case 'Dog':
        case 'Cat':
          return 0.1;
        default:
          return 0.1;
      }
    }
  }, {
    key: 'maximumAnimalWeight',
    value: function maximumAnimalWeight(animalType) {
      if (!animalType) {
        return 2500.0;
      }

      switch (animalType) {
        case 'Horse':
          return 2500.0;
        case 'Dog':
          return 200.0;
        case 'Cat':
          return 30.0;
        default:
          return 2500.0;
      }
    }
  }]);

  return AnimalTypeService;
}();

exports.default = AnimalTypeService;


// WEBPACK FOOTER //
// ./services/animal-type.service.js